var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOvers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 35C13.0278 35 9.13079 33.5174 5.80903 30.5521C2.48727 27.5868 0.583333 23.8843 0.0972222 19.4444H4.08333C4.53704 22.8148 6.03588 25.6019 8.57986 27.8056C11.1238 30.0093 14.0972 31.1111 17.5 31.1111C21.2917 31.1111 24.5081 29.7905 27.1493 27.1493C29.7905 24.5081 31.1111 21.2917 31.1111 17.5C31.1111 13.7083 29.7905 10.4919 27.1493 7.85069C24.5081 5.20949 21.2917 3.88889 17.5 3.88889C15.2639 3.88889 13.1736 4.40741 11.2292 5.44444C9.28472 6.48148 7.64815 7.90741 6.31944 9.72222H11.6667V13.6111H0V1.94444H3.88889V6.51389C5.54167 4.43981 7.55903 2.83565 9.94097 1.70139C12.3229 0.56713 14.8426 0 17.5 0C19.9306 0 22.2072 0.461806 24.3299 1.38542C26.4525 2.30903 28.2998 3.55671 29.8715 5.12847C31.4433 6.70023 32.691 8.54745 33.6146 10.6701C34.5382 12.7928 35 15.0694 35 17.5C35 19.9306 34.5382 22.2072 33.6146 24.3299C32.691 26.4525 31.4433 28.2998 29.8715 29.8715C28.2998 31.4433 26.4525 32.691 24.3299 33.6146C22.2072 34.5382 19.9306 35 17.5 35ZM22.9444 25.6667L15.5556 18.2778V7.77778H19.4444V16.7222L25.6667 22.9444L22.9444 25.6667Z",
    fill: "#8CA4FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOvers);
export default __webpack_public_path__ + "static/media/Overs.753197973d6d32d8767fb735fef6689a.svg";
export { ForwardRef as ReactComponent };